import React, { ErrorInfo } from "react";
import { ErrorBoundary } from "react-error-boundary";
import Zendesk, { IZendeskProps } from "react-zendesk";
import { ZENDESK_KEY } from "./zendesk_settings";
import { captureError } from "../../../utils/capture_error";

interface ZendeskWidgetProps extends Omit<IZendeskProps, "zendeskKey"> {}

const logError = (error: Error, info: ErrorInfo) => {
  captureError(new Error(`Error in ZendeskWidget: ${error.message} ${info.componentStack}`));
};

const ZendeskWidget = (props: ZendeskWidgetProps) => {
  // For now, we are just returning an empty fragment as a fallback.
  // The ErrorBoundary component will catch any errors and log them to Sentry.
  const fallback = <></>;

  return (
    <ErrorBoundary fallback={fallback} onError={logError}>
      <Zendesk defer {...props} zendeskKey={ZENDESK_KEY} />
    </ErrorBoundary>
  );
};

export default ZendeskWidget;
